import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { ChevronLeft, Sparkles } from 'lucide-react';
import { changelogApi } from '../../api/changelogApi';
import { formatChangelogDate } from './changelogFormat';

// Полный лог одного конкретного релиза — открывается по клику из списка
// «Что нового» (Changelog.tsx). Данные берутся из того же кэша react-query,
// что и список, поэтому переход на эту страницу обычно происходит без
// дополнительного запроса к серверу.
export function ChangelogDetail() {
  const nav = useNavigate();
  const { version } = useParams<{ version: string }>();
  const { data, isLoading } = useQuery({ queryKey: ['changelog'], queryFn: () => changelogApi.getStatus() });
  const entry = data?.entries.find((e) => e.version === version);

  return (
    <div className="rf-detail">
      <div className="rf-topbar">
        <button className="rf-back" onClick={() => nav(-1)}>
          <ChevronLeft /> Что нового
        </button>
      </div>

      <div className="rf-detail-scroll">
        {isLoading && <div className="rf-info">Загрузка…</div>}
        {!isLoading && !entry && (
          <div className="rf-info"><Sparkles /><div>Эта запись не найдена.</div></div>
        )}
        {entry && (
          <div className="rf-card" style={{ padding: 18 }}>
            <div style={{ fontWeight: 700, fontSize: 19, lineHeight: 1.3, marginBottom: 6, color: 'var(--rf-text, #e8ecf4)' }}>
              {entry.title}
            </div>
            <div style={{ fontSize: 13, color: 'var(--rf-accent, #2e86ff)', fontWeight: 600, marginBottom: 18 }}>
              Версия от {formatChangelogDate(entry.date)}
            </div>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              {entry.highlights.map((h, i) => (
                <li key={i} style={{ marginBottom: 10, lineHeight: 1.6, fontSize: 15, color: 'var(--rf-text, #e8ecf4)' }}>{h}</li>
              ))}
            </ul>
            {entry.channelUrl && (
              <div style={{ marginTop: 18, paddingTop: 14, borderTop: '1px solid var(--rf-border, rgba(255,255,255,0.08))' }}>
                <a
                  href={entry.channelUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{ fontSize: 14, fontWeight: 600, color: 'var(--rf-accent, #2e86ff)', textDecoration: 'none' }}
                >
                  Подробности в канале →
                </a>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default ChangelogDetail;
